<template>
  <div class="dashboard">
    <toolbar>
      <template slot="menu">
        <i-menu class="profile-navmenu" mode="horizontal" theme="dark">
          <router-link class="ivu-menu-item" :to="`/app/dashboard/actual`">
            Актуальные задачи
          </router-link>
          <router-link class="ivu-menu-item" :to="`/app/dashboard/history`">
            Активность
          </router-link>
        </i-menu>
      </template>
    </toolbar>
    <div :class="['ms-container', isFullWidthRoute ? 'full-width' : '']">
      <router-view />
    </div>
  </div>
</template>

<script>
import Toolbar from '@/components/toolbar/toolbar'

export default {
  components: {
    Toolbar
  },
  computed: {
    isFullWidthRoute () {
      return (
        this.$route.path.indexOf('dashboard/actual/month') > -1 ||
        this.$route.path.indexOf('dashboard/actual/week') > -1
      )
    }
  }
}
</script>

<style lang="less">
.profile-navmenu {
  &.ivu-menu {
    z-index: 400;
  }
}
</style>
